import useTranslate from 'hooks/useTranslate';
import React from 'react';
import { Button, Modal, Stack } from 'react-bootstrap';
import useCommonStore from 'store/common';

const ConfirmModal: React.FC<any> = () => {
	const { translate } = useTranslate();
	const { modalConfig = {}, hideCommonModal }: any = useCommonStore((state) => state);
	return (
		<Modal.Body>
			<Stack className="gap-4 text-center">
				{modalConfig?.data?.title && <h2 className="fw-bold mb-0">{modalConfig.data.title}</h2>}
				<div className="edit-modal-actions d-flex gap-3 gap-md-4 justify-content-center">
					<Button
						className="transparent-btn rounded-pill"
						onClick={() => (modalConfig?.onClose ? modalConfig?.onClose() : hideCommonModal())}
					>
						{translate('Modal.no')}
					</Button>
					<Button className="filled-btn rounded-pill" onClick={() => modalConfig?.onClick()}>
						{translate('Modal.yes')}
					</Button>
				</div>
			</Stack>
		</Modal.Body>
	);
};

export default ConfirmModal;
